import { notificationsListQuery } from '@/entities/notifications';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useNotificationsList() {
  const { data, isPending } = useAppQuery({
    ...notificationsListQuery({}),
  });

  return { notifications: Array.isArray(data) ? data : [], isPending };
}
